import { RootState } from '../rootReducer';

export const selectUser = (state: RootState) => state.user.user.user;
export const selectUserIsPRO = (state: RootState) => state.user.user.isPRO;
